import { Navigate, Route, Routes } from "react-router-dom";
import { useUser } from "../../common/context/UserProvider";
import { hasSalesOrAdminAccess } from "../../utils";
import AlqemiAnalytics from "./AlqemiAnalytics";

export default function AlqemiAnalyticsRoutes() {
  const { user } = useUser();

  if (!hasSalesOrAdminAccess(user)) {
    return <Navigate to="/user-settings" replace />;
  }

  return (
    <Routes>
      <Route index element={<AlqemiAnalytics />} />
    </Routes>
  );
}
